import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/sagas/funnelChart";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import { DatePicker } from "./smartComponents/DatePicker";
import { CustomDateRanges } from "./smartComponents/CustomDateRange";
import { LaserFunnelGraph } from "./smartComponents/FunnelGraph";
import { IntroOfferFunnelGraph } from "./smartComponents/IntroOfferFunnelGraph";
import { ReferralBreakdownTable } from "./smartComponents/ReferralBreakdownTable";
import { StartFrom } from "./smartComponents/StartFrom";
import { Averages } from "./smartComponents/Averages";
import { SubAverageFilter } from "./smartComponents/SubAverageFilter";
import { LaserLearnMore } from "./smartComponents/LaserLearnMore";
import { addSticky } from "../../../utils/addSticky";
import { FutureAppointmentsToggle } from "./smartComponents/FutureBookingsToggle";
import { LooseConversionsToggle } from "./smartComponents/LooseConversionsToggle";
import { UpdateBtns } from "./smartComponents/UpdateBtns";
import { IntroOfferDataPoints } from "./smartComponents/IntroOfferDataPoints";
import { DataPoints } from "./smartComponents/DataPoints";
import { ProspectTypes } from "./smartComponents/ProspectTypes";
import { ExcludeEnrolledToggle } from "./smartComponents/ExcludeEnrolledToggle";

export const FunnelGraphModule = (props) => {
  const dispatch = useDispatch();

  let showLaserNetworkAverages = useSelector(
    (state) => state.laser.currentUser.showLaserNetworkAverages
  );

  let isLoading = useSelector((state) => state.laser.isLoading);
  let tablesLoading = useSelector((state) => state.laser.tablesLoading);
  let initialRequest = useSelector((state) => state.laser.initialRequest);

  let { data } = useSelector((state) => state.laser.referralTable.referrals_table.tableInfo);

  let startFrom = useSelector((state) => state.laser.selectedFilters.startFrom.id);
  let isIntroOfferSelected = startFrom == "introOffer";

  let title = useSelector((state) =>
    isIntroOfferSelected
      ? state.laser.funnelIntroOffers.chart.label
      : state.laser.funnelChartData.chart.title
  );

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchData(props));
    }
  }, []);

  useEffect(() => {
    if (!isLoading) {
      addSticky();
    }
  }, [isLoading]);

  const renderChartFilters = () => {
    return (
      <div className={showLaserNetworkAverages ? "with-average" : ""}>
        {/** Select Filters */}
        <div data-testid="filters" className="filters">
          <div className="top-filters">
            <div>
              <ProspectTypes />

              <div className="select-box">
                <p className="offers-title">Date Range</p>
                <CustomDateRanges />
              </div>

              <div className="date-select-box select-box multi" style={{ width: "286px" }}>
                <p className="offers-title">Date</p>
                <DatePicker />
              </div>
            </div>
            <div className="start-from-wrapper">
              {showLaserNetworkAverages ? (
                <div className="select-box" style={{ width: "150px" }}>
                  <p className="offers-title">Averages</p>
                  <Averages />
                </div>
              ) : null}

              <SubAverageFilter />
            </div>
          </div>

          <UpdateBtns showFutureAppointment={props.showFutureAppointment} />
        </div>

        {/** Switch Filters */}
        <div className="filters">
          <div>
            <FutureAppointmentsToggle showFutureAppointment={props.showFutureAppointment} />

            <LooseConversionsToggle />

            <ExcludeEnrolledToggle />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div data-testid="funnel-chart-module" className="funnel-chart-module">
      <SectionToggle
        autoHeight
        title={props.moduleName + " start from"}
        customClass="laser withSticky"
        isLoading={isLoading}
        learnMore={
          <>
            <StartFrom />
            <LaserLearnMore
              title={props.moduleName}
              showFutureAppointment={props.showFutureAppointment}
            />
          </>
        }
        content={
          <div className="flex flex-col">
            {/* Filters */}
            <div id="sticky-select-bar" className="edit-selections-bar">
              {renderChartFilters()}
            </div>
            {tablesLoading ? (
              <LoadingAnimation />
            ) : (
              <div className="flex flex-col" style={{ paddingTop: "50px" }}>
                {/* Number summaries */}
                {isIntroOfferSelected ? <IntroOfferDataPoints /> : <DataPoints />}

                {/* Graph section */}
                <div style={{ paddingTop: 25, float: "left" }}>
                  <SectionContainer title={title} style={{ padding: "0 100px 0 0" }}>
                    {isIntroOfferSelected ? <IntroOfferFunnelGraph /> : <LaserFunnelGraph />}
                  </SectionContainer>
                </div>
                {/* Table section */}
                <div className="section-group flex" style={{ paddingTop: 50 }}>
                  <SectionContainer title="" rootClassName="referral-breakdown-container">
                    {data.length > 0 ? <ReferralBreakdownTable /> : null}
                  </SectionContainer>
                </div>
              </div>
            )}
          </div>
        }
      />
    </div>
  );
};
